import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import usuariosReducer from './usuariosReducer';
import vendorReducer from './vendorReducer';
import companyNamesReducer from './companyNamesReducer';

const rootReducer = combineReducers({
    session: sessionReducer,
    usuarios: usuariosReducer,
    vendor: vendorReducer,
    companyNames: companyNamesReducer,
});

export default rootReducer;
